import ConfirmDialog from '@/pages/Business/pages/LogisticOperator/pages/components/ConfirmDialog';
import { useRef, useState } from 'react';

export interface ConfirmOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export type Confirm = (options: ConfirmOptions) => Promise<boolean>;

const useConfirmDialog = () => {
  const [options, setOptions] = useState<ConfirmOptions | null>(null);
  const resolver = useRef<((confirmed: boolean) => void) | null>(null);

  const confirm: Confirm = (next) =>
    new Promise<boolean>((resolve) => {
      resolver.current = resolve;
      setOptions(next);
    });

  const close = (confirmed: boolean) => {
    resolver.current?.(confirmed);
    resolver.current = null;
    setOptions(null);
  };

  const dialog = (
    <ConfirmDialog
      open={!!options}
      title={options?.title}
      message={options?.message ?? ''}
      confirmLabel={options?.confirmLabel}
      cancelLabel={options?.cancelLabel}
      onConfirm={() => close(true)}
      onClose={() => close(false)}
    />
  );

  return { confirm, dialog };
};

export default useConfirmDialog;
